import React from "react";
import { STEPS } from "../config/siteConfig";

const HowItWorks= () => {
  return (
    <section className="py-24 bg-zinc-950">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-amber-600/60 tracking-[0.3em] uppercase text-xs mb-4">
            Comment ça marche
          </p>
          <h2
            className="text-4xl md:text-5xl font-display"
            style={{ color: "#BB9D63" }}
          >
            Simple & élégant
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {STEPS.map((step, i) => (
            <div key={step.num} className="relative group">
              {i < STEPS.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-[60%] w-[80%] h-px bg-gradient-to-r from-amber-800/30 to-transparent" />
              )}
              <span
                className="text-5xl font-black opacity-10 block mb-3 font-display"
                style={{ color: "#BB9D63" }}
              >
                {step.num}
              </span>
              <h3 className="text-lg text-white mb-2 tracking-wide">
                {step.title}
              </h3>
              <p className="text-zinc-500 text-sm leading-relaxed">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
